<div class="modal-header justify-content-center px-5 py-4">
  <h2 class="font-20 montserrat-semibold text-center">Harappa: Assessments & Scoring Guidelines</h2>
  <button type="button" class="close" data-dismiss="modal" (click)="close()"><i class="icon-close"></i></button>
</div>
<div class="modal-body px-5 pt-4 navColor">
  <div *ngFor="let item of faqData">
    <h3 *ngIf="item.title" class="font-18 montserrat-semibold mg-b10">{{item.title}}</h3>
    <p *ngIf="item.description" class="font-16 mg-b40" [innerHTML]="item.description"></p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="close()"><span>Close</span></button>
</div>